import { QuarantinedDocumentsUpdateRequest } from "./quarantined-documents-update-request";

export class QuarantinedDocumentsRejectRequest  {
    reasonForRejection: string;
    quarantineDocumentsToReject: QuarantinedDocumentsUpdateRequest[];
    public constructor(reasonForRejection: string, quarantineDocumentsToReject: QuarantinedDocumentsUpdateRequest[]) {
        this.reasonForRejection = reasonForRejection;
        this.quarantineDocumentsToReject = quarantineDocumentsToReject;
    }
}
